import { KnowledgeSpaceRole } from '@this+that/models';

/**
 * Constants for the Knowledge feature's system (bootstrap) spaces.
 *
 * R-ASY-001: Each new team gets 3 auto-created system spaces.
 * The spaceId for each is deterministic via uuidv5 so that stream redelivery
 * re-attempts produce the same UUIDs and the ConditionExpression
 * attribute_not_exists(spaceId) treats them as no-ops (idempotent).
 *
 */

export const KP_IMAGE_SCHEME = 'kp-image://';
export const KP_ATTACHMENT_SCHEME = 'kp-attachment://';

export const READ_ROLES = [
  KnowledgeSpaceRole.VIEWER,
  KnowledgeSpaceRole.EDITOR,
  KnowledgeSpaceRole.MANAGER,
] as const;

export const EDIT_ROLES = [
  KnowledgeSpaceRole.EDITOR,
  KnowledgeSpaceRole.MANAGER,
] as const;

export const MANAGE_ROLES = [KnowledgeSpaceRole.MANAGER] as const;

export const DEFAULT_TEAM_ROLE = KnowledgeSpaceRole.EDITOR;

export const MAX_PAGE_DEPTH = 10;
export const MAX_PAGES_PER_SPACE = 500;

export const KNOWLEDGE_SPACES_PAGE_SIZE = 20;
// Caps per-request field-resolver fan-out (owner/participants run per space), not the
// total spaces a user can have — the frontend background loop keeps paginating past this.
export const KNOWLEDGE_SPACES_MAX_LIMIT = 100;

export const MOVE_TX_CAPACITY = 90;
export const SAME_SPACE_MOVE_FIXED_OPS = 2;
export const CROSS_SPACE_MOVE_FIXED_OPS = 4;
export const CROSS_SPACE_MOVE_OPS_PER_PAGE = 2;
